export { blockDraggingToIFrames } from '../../public-utils/element/block-dragging-to-iframes';
